import React from 'react';

import { I18n } from '@aws-amplify/core';

import {
	RISK_LEVEL_COLORS,
	RISK_LEVEL_LABEL_KEYS
} from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

export function RiskLegend() {
	return (
		<S.RiskLegendContainer>
			{Object.entries(RISK_LEVEL_LABEL_KEYS).map(([key, label]) => (
				<S.RiskLegendItem key={key}>
					<S.RiskColorBox $color={RISK_LEVEL_COLORS[key as keyof typeof RISK_LEVEL_COLORS]} />
					<S.RiskLabel>{I18n.get(label)}</S.RiskLabel>
				</S.RiskLegendItem>
			))}
		</S.RiskLegendContainer>
	);
}
